export default "__VITE_ASSET__D3191P3A__"